<template>
  <v-row class="skeleton">
    <v-col cols="12" lg="8" class="px-6">
      <h1 class="welcome" data-public>Loading...</h1>
      <v-row>
        <v-col>
          <v-skeleton-loader class="theme__border" type="table" />
        </v-col>
      </v-row>
    </v-col>
    <v-col class="pa-0 bg-white theme__border__left" style="min-height: 100vh">
      <v-skeleton-loader
        type="list-item, divider, list-item-avatar-two-line, divider, list-item-avatar-two-line, divider, list-item-avatar-two-line, divider"
      />
      <v-skeleton-loader
        type="list-item, divider, list-item-avatar-two-line, divider, list-item-avatar-two-line, divider, list-item-avatar-two-line"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.skeleton {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 4;
  width: 100%;
  background-color: rgb(236, 245, 253);
}
</style>